import {
  objectToCamelCase,
  objectToSnakeCase,
  formatDateShort,
  formatNumberAsUSD,
} from '@/services/utils'

import api from './api'
import options from './options'

export default class Nomination {
  static api = api.create(Nomination)
  static options = options
  static readOnlyFields = [
    'id',
  ]

  constructor(json) {
    Object.assign(this, {
      ...json,
    })
  }

  static create(opts) {
    return new Nomination(opts)
  }

  static fromAPI(json) {
    return new Nomination(objectToCamelCase(json))
  }

  static toAPI(request = null, fields = [], excludeFields = [], kwargs = null) {
    let data = {}

    if (kwargs) {
      delete kwargs.id
      data = kwargs
    } else {
      // By default, send the whole object
      // If it's a partial update, get only the fields specified

      if (fields.length > 0) {
        fields.forEach(field => {
          data[field] = request[field]
        })
      } else {
        data = request
      }

      //
      excludeFields = [...Nomination.readOnlyFields, ...excludeFields]
      excludeFields.forEach(item => {
        delete data[item]
      })
    }

    return objectToSnakeCase(data)
  }

  static checkIsInstance(obj, name) {
    if (!(obj instanceof Nomination)) {
      throw Error(`${name} must be an instance of the Stipend Request class.`)
    }
  }
}